var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"type":"text","label":"City, State","solo":"","prepend-inner-icon":"mdi-magnify","full-width":""},on:{"keypress":_vm.setSearch},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }